import { isEventTicketItemData } from 'common/helpers/featureFlags';

const EventItemData = (props) => {
  const { item } = props;
  if (!isEventTicketItemData(item.type, item.sku)) {
    return null;
  }
  if (!item.itemData) {
    return null;
  }
  if (!item.itemData.recipients) {
    return null;
  }
  return (
    <>
      {item.itemData.recipients.map((recipient, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="c7-cart-items__title__variant">
          {index + 1}: {recipient.name} {recipient.email}
        </div>
      ))}
    </>
  );
};

export default EventItemData;
